import {
  DashboardScreen,
  TranslationsType,
  MainMenu,
  General,
  MyWalletScreen,
  SignScreen,
  FastConvertScreen,
  WithdrawScreen,
  DepositScreen,
  MoneyDepositScreen,
  HistoryScreens,
  ProfileInfo,
  TradeScreen,
  AboutUs,
  Confirmations,
  NavSearchBox,
  SearchRsultPage,
  Searchpage,
  NavUserLogin,
  Mainslider,
  Guneshcomponent,
  Guneshcard,
  Footer,
  Product,
  Productscontiner,
  NavTop,
  Elementors,
  RecentContent,
  Representationcart,
  UserPanel,
  SignIn,
  NewUser,
  Productdetile,
  Blogitem,
  Contactus,
  Blogdetile,
  OptionItem,
  Productitem,
  Cooperate,
  HomeParanox

} from "./types";

const aboutUs: AboutUs = {
  AboutUsTitle: "درباره ما",
  AboutUsTitle2: "چرا ما؟",
  AboutUsTitle3: "اعضای هیئت مدیره",
  BodyText1: "شرکت پترونام سهند از سال ۱۳۹۷ با تکیه بر علم و تجربه ی مدیران خود اقدام به تولید نانو افزودنی های روغن موتور توانسته گام بلندی در زمینه تولید روغن موتور های نانویی در کشور نماید که کیفیت روغن موتور این شرکت را به یکی از بهترین ها ی نه تنها ایران بلکه دنیا تبدیل کرده است. نانو افزودنی ها مورد استفاده شرکت پترونام تنها در چند شرکت معتبر جهانی همچون شل، موبیل ۱ و یکی از افزودنی ها تنها در ناسا مورد استفاده قرار میگیرد. نکته بارز این شرکت استفاده همزمان چندین نانو افزودنی است که باعث گردیده کیفیت محصولات ما نسبت به رقبای معتبر خارجی کاملا مشهود باشد.  به کارگیري نانو افزودنیهاي این شرکت در روانکارها باعث کاهش اصطکاك و سایش، کاهش مصرف سوخت و انرژي، کاهش چشمگیر صدای موتور، کاهش آلودگیهاي زیست محیطی  و بهبود عملکرد روانکارها میگردد که علت آن را میتوان در ساختار خاص این دسته از مواد افزودنی دانست. از ویژگی های منحصر بفرد این نانو افزودنی ها قابلیت ترمیم داخل موتور می باشد.",
  BodyText2: "امروزه روغن‌های موتور علاوه بر روانکاری و کاهش سایش قطعات موتور دارای کارکردهایی نظیر آب‌بندی فواصل بین قطعات، شست‌وشو و تمیزکردن قطعات از دوده و ترکیبات حاصل از تجزیه روغن و رسوبات، محافظت از سطوح در مقابل زنگ‌زدگی و خوردگی شیمیایی، ضربه گیری، معلق نگه‌داشتن مواد زائد و جلوگیری از رسوب آن‌ها بر روی قطعات نیز هستند. اما از آن‌جایی که روانکارهای مایع قادر نیستند تمامی ویژگی‌های مورد نیاز فوق را به نحوی مطلوب فراهم آورند، به منظور دستیابی به بسیاری از خواص فوق و یا بهبود آن‌ها از افزودنی‌های روغن موتور استفاده می‌شود. در این میان استفاده از نانوافزودنی‌ها با هدف افزایش بازدهی موتور از طریق ارائه خواص فوق و همچنین صرفه‌جویی در مصرف سوخت در سال‌های گذشته بسیار مورد توجه قرار گرفته‌است. این نانوافزودنی‌ها با چند سازوکار عملکردی شامل تبدیل اصطکاک لغزشی به اصطکاک غلتشی، قابلیت انتقال حرارت بسیار بالا، ترمیم سطوح اصطکاکی و نیز تشکیل فیلم محافظ برروی سطوح اصطکاکی منجر به بهبود و تقویت خواص روانکار مایع پایه می‌شوند. بر همین اساس شرکت پترونام  پس از سالها تحقیقات موفق به تولید نانو افزودنی هایی گردیده که انقلابی را در صنعت روانکاری و بهبود عملکرد روغن موتورهای دیزلی و بنزینی ایجاد کرده و پس از سالها تست میدانی اخیرا شروع به عرضه محصولات خود به بازار نموده است. این محصول بی نظیر و بی رقیب در ایران و حتی خاورمیانه و یکی از بهترین روغن های موجود حال حاضر دنیاست. نانو افزودنی ها مورد استفاده شرکت پترونام تنها در چند شرکت معتبر جهانی همچون شل، موبیل ۱ و یکی از افزودنی ها تنها در ناسا مورد استفاده قرار میگیرد. نکته بارز این شرکت استفاده همزمان چندین نانو افزودنی است که باعث گردیده کیفیت محصولات ما نسبت به رقبای معتبر خارجی کاملا مشهود باشد.",
  BodyTextList1: "اصالت برند کالا",
  BodyTextList2: "قیمت مناسب",
  BodyTextList3: "تحویل فوری",
  BodyTextList4: "خدمات پس ار فروش",
}

const confirmations: Confirmations = {
  ConfirmationsTitle: 'تاییدیه ها و گواهینامه ها',
}
const navSearchBox: NavSearchBox = {
  NavSearchBoxTitle: "جستجو...",
}
const searchRsultPage: SearchRsultPage = {
  ShowDetails: "مشاهده جزئیات محصول",
}
const searchPage: Searchpage = {
  SearchPageTitle: "نتیجه جستجو",
  ResultNotFound: 'جستجوی مورد نظر یافت نشد',
  BackToMainpage: 'بازگشت به صفحه اصلی',
}
const navUserLogin: NavUserLogin = {
  LoginToAccount: 'ورود به حساب',
}

const navTop: NavTop = {
  NavTopAddress: 'آبرسان، نرسیده به بیمارستان شمس، نبش فلکه هفت تیر، رستوران مرواریدآبرسان',
  NavTopPhone: '04136565776 -  09141181424',
}

const elementors: Elementors = {
  ElementorsTitle1: 'پیشتـاز بودن',
  ElementorsTitle2: 'مشتـری مـداری',
  ElementorsTitle3: 'سازگـار با محیـط زیسـت',
  ElementorsTitle4: 'رقابـت با برندهای معتبـر',
  ElementorsBody1: 'پترونام با بکارگیری نانو افزودنی‌ها و پیاده سازی علم دنیا، در عرصه تولید روغن موتور پیشتاز است.',
  ElementorsBody2: 'تمام فناوری‌های به کار برده شده در محصولات پترونام در راستای رضایت شما مشتریان عزیز است.',
  ElementorsBody3: 'محصولات پترونام با کاهش مصرف بنزین و کاهش آلاینده‌ها در خودروها، سازگار با محیط زیست می‌باشد.',
  ElementorsBody4: 'ما در پترونام با بکارگیری نانو افزودنی‌ها در محصولات خود، با برندهای معتبر جهانی در رقابت هستیم.',
}

const recentContent: RecentContent = {
  RecentContentTitle: 'مطالب اخیر',
  RecentContentBtn: 'مشاهده همه',
}

const representationCart: Representationcart = {
  RepresentationcartTitle: 'نمایندگی',
  RepresentationcartPhone: 'شماره تماس',
  RepresentationcartAddress: 'آدرس',
  RepresentationcartInfo: 'اطلاعات',
}

const userPanel: UserPanel = {
  userPanelProfile: 'پروفایل',
  userPanelInbox: 'صندوق پیام',
  userPanelExit: 'خروج از حساب',
}

const signIn: SignIn = {
  SignInTitle: 'ورود به حساب کابری',
  SignInUserName: 'نام کاربری یا ایمیل',
  SignInPassword: 'رمز عبور',
  SignInRememberMe: 'مرا به خاطر بسپار',
  SignInLogin: 'ورود',
  SignInDontHaveAccount: 'حساب کاربری ندارید؟',
  SignInRegister: 'ثبت نام',
  SignInForgotPassword: 'رمز عبور خود را فراموش کرده اید؟',
  ErrorMessageUserNameEmpty: 'نام کاربری خالی می باشد',
  ErrorMessageUserName: 'نام کاربری اشتباه می باشد',
  ErrorMessagePasswordEmpty: 'رمز عبور خالی می باشد',
  ErrorMessagePassword: 'رمز عبور اشتباه می باشد',
}
const newUser: NewUser = {
  NewUserTitle: 'ثبت نام',
  NewUserRegister: 'ثبت نام',
  NewUserBackToLoginIn: 'بازگشت به صفحه ورود',
  NewUserUserName: 'نام کاربری:',
  NewUserPhone: 'شماره تلفن:',
  NewUserEmail: 'ایمیل:',
  NewUserPassword: 'رمز عبور:',
  NewUserRePassword: 'تکرار رمز عبور:',
  ErrorMessageUserNameEmpty: 'نام کاربری خالی می باشد',
  ErrorMessagePhoneEmpty: 'شماره تلفن خالی می باشد',
  ErrorMessagePhone: 'شماره تلفن اشتباه می باشد',
  ErrorMessageEmailEmpty: 'ایمیل خالی می باشد',
  ErrorMessageEmail: 'ایمیل اشتباه می باشد',
  ErrorMessagePasswordEmpty: 'رمز عبور خالی می باشد',
  ErrorMessageRePassword: 'تکرار رمز عبور اشتباه می باشد',
  ErrorMessageRePasswordEmpty: 'تکرا رمز عبور خالی می باشد',
}

//A:mycomponents------------

const mainSlider: Mainslider = {
  ShowMore: 'مشاهده بیشتر',
}

const guneshComponent: Guneshcomponent = {
  ShowMoreProduct: 'مشاهده محصولات بیشتر',
  BestSellingProducts: 'محصولات پرفروش',
}
const guneshCard: Guneshcard = {
  AddToCart: 'تماس بگیرید',
  ProductTitle: 'عنوان محصول',
}


const footer: Footer = {
  WeWating: 'منتظر دیدارتان هستیم:',
  CustomerGuide: 'راهنمای مشتری',
  HowToOrder: 'نحوه سفارش گیری',
  HowToTrackTheOrder: 'نحوه پیگیری سفارش',
  OrderSubmissionProcess: 'روند ارسال سفارش',
  followUs: 'ما را در فضای مجازی دنبال کنید:',
  WhatNeedToNow: 'هر آنچه لازم است درباره شرکت پترونام سهند بدانید:',
  CopyRight: 'تمام حقوق سایت محفوظ می باشد.',
  Compony: 'شرکت گونش بیلگی سایار سهند ',

}


const product: Product = {
  AllProducts: 'همه محصولات',
  Categories: 'دسته بندی ها',
}


const productsContiner: Productscontiner = {
  LoadMoreProducts: 'بارگذاری محصولات بیشتر',
  NotMessage: 'محصولی برای نمایش وجود ندارد.',
  ShowAllProducts: 'مشاهده همه محصولات',
  SortByLatest: 'مرتب سازی بر اساس:جدیدترین',
  SortByAscPrice: 'مرتب سازی بر اساس هزینه:کم به زیاد',
  SortByDesPrice: 'مرتب سازی بر اساس هزینه:زیاد به کم',
}


const productDetile: Productdetile = {
  ProductDetails: 'جزئیات محصول :',
  Attributes: 'ویژگی ها :',
  Viscosity: 'گرانروی :',
  Capacity: 'حجم',
  Quality: ':کیفیت :',
  Model: 'مدل :',
  Price: 'قیمت :',
  Toman: 'تومان',
  AddToCart: 'افزودن به سبد',
  OtherDetails: 'سایر توضیحات',
  GeneralSpecifications: 'مشخصات کلی',
}

const blogItem: Blogitem = {
  ReadMore: 'ادامه مطلب',
}

const contactUs: Contactus = {
  Contact: 'تماس با ما',
  Address1: "آدرس 2",

  Address: 'آدرس ',
  Phone: 'تلفن',
  WorkingHours: 'ساعات کار',
  Email: 'ایمیل',
  ComponyOnMap: ' آدرس رستوران مروارید',
  SelectTopic: 'انتخاب موضوع',
  Criticism: 'انتقاد',
  Complaint: 'شکایت',
  OrderTracking: 'پیگیری سفارش',
  Originality: 'استعلام اصالت کالا',
  Name: 'نام',
  Family: 'نام خانوادگی',
  Mobile: 'شماره تلفن',
  MessageText: 'متن پیام',
  RegisterAndSend: 'ثبت و ارسال',
}


const blogDetile: Blogdetile = {
  UsersOptions: 'نظرات کاربران',
  SendMessage: 'لطفا نظرات خود را با ما در میان بگذارید.',
  ReplayTo: 'پاسخ به :',
  Name: 'نام',
  Family: 'نام خانوادگی',
  OptionText: 'متن نظر',
  Send: 'ارسال',
}
const cooperate: Cooperate = {
  CSendMessage: 'در صورت تمایل به همکاری از طریق فرم زیر با ما ارتباط برقرار کنید',
  CName: 'نام',
  CFamily: 'نام خانوادگی',
  COptionText: 'متن نظر',
  CSend: 'ارسال',
}

const optionItem: OptionItem = {
  ReplayTO: 'پاسخ به : ',
  Replay: 'پاسخ ',
}

const productItem: Productitem = {
  Title: 'عنوان محصول',
  Toman: 'تومان',
  AddToCart: 'تماس بگیرید',
}

//--------------------------






const dashboardScreen: DashboardScreen = {
  title: "البیتکوین",
};

const myWalletScreen: MyWalletScreen = {
  historyTitle: 'my wallets'
}




const mainMenu: MainMenu = {
  // DashboardTitle: 'داشبورد',
  // ActiveOrdersTitle: 'سفارشات باز',
  // MainMarketTitle: 'بازار اصلی',
  // MyWalletTitle: 'کیف های من',
  // ProfessionalMarketsTitle: 'بازار حرفه ای',
  // MarketOrderTitle: 'سفارش سریع',
  // fastConvertTitle: 'تبدیل سریع'
  TitleHome: "خانه",
  TitleProducts: 'محصولات',
  TitleRepresentation: 'اخذ نمایندگی',
  TitleCooperate: 'دعوت به همکاری',
  TitleWeblog: 'وبلاگ',
  TitleAboutUs: 'درباره ما',
  TitleContactUs: 'ارتباط با ما',
  TitleSaveOrder: 'سفارش غذا',
  TitleCooperateMain: 'همکاری با پترونام',
  TitleParanox: 'روغن موتور پارانوکس'
}

const signScreen: SignScreen = {
  SignupTitle: "ثبت نام",
  Emailaddress: "شماره موبایل",
  Password: "رمز عبور",
  RepeatPassword: "تکرار رمز عبور",
  AcceptRules1: "",
  AcceptRules2: "قوانین و شروط",
  AcceptRules3: "خدمات گونش بیلگ سایار را مطالعه کردم و می‌پذیرم.",
  InvitationCode: "کد دعوت",
  InvitationCodeTextInfo: "* در صورتی که از دوستان خود کد دعوت دریافت کرده‌‌اید، وارد نمایید.",
  AlreadyHaveAnAccount: "قبلاً حساب دارید؟",
  AlreadyHaveAnAccountSigninLink: "ورود",
  SapratorSignupAndGoogleAccount: "یا",
  SignWithGoogle: "ورود با حساب گوگل",
  RememberMe: "مرا بخاطر بسپار",
  SigninTitle: "ورود",
  DoNotHaveAccount: "اگر حساب کاربری ندارید؟",
  loginErrorLabel: 'شماره موبایل یا رمز عبور اشتباه است',
  Name: "نام",
  Last: "نام خانوادگی"

}

const general: General = {
  amount: 'مقدار',
  deposit: 'واریز',
  options: 'امکانات',
  price: 'قیمت',
  withdraw: 'برداشت',
  currentFee: 'کارمزد فعلی',
  filled: 'پرشده',
  market: 'بازار',
  orderPrice: 'قیمت سفارش',
  state: 'وضعیت',
  time: 'زمان',
  totalPrice: 'مبلغ کل',
  type: 'وضعیت',
  direction: 'سمت',
  cancel: 'لغو',
  fastConvert: 'تبدیل سریع',
  coin: 'ارز',
  delete: 'حذف',
  logoutLabel: 'خروج از حساب',
  myMessagesLabel: 'صندوق پیام',
  profileLabel: 'پروفایل',
  settingsLabel: 'تنظیمات',
  noRowsToDisplayLabel: 'داده ای برای نمایش وجود ندارد',
  balance: 'موجودی',
  priceUnit: 'تومان'
}


const fastConvertScreen: FastConvertScreen = {
  pageTitle: 'تبدیل سریع',
  modeDropDownData: [
    { value: "few", label: "تبدیل مقادیر کم به ریال" },
    { value: "torls", label: "تبدیل همه مقادیر به ریال" },
    { value: "tousdt", label: "تبدیل همه مقادیر به تتر" },
  ],
  modeLabel: 'عملیات',
  convertButtonText: 'تبدیل سریع'
}

const withdrawScreen: WithdrawScreen = {
  amountLabel: 'مبلغ برداشت',
  backButton: 'بازگشت',
  createRequestButton: 'ایجاد درخواست',
  feeLabel: 'کارمزد',
  pageTitle: 'درخواست برداشت',
  targetWalletLabel: 'آدرس کیف پول مقصد',
  twoFactorLabel: 'کد شناسایی دوعاملی',
  viewFeeButton: 'مشاهده کارمزدها',
  activeWithdrawAmount: 'موجودی قابل برداشت',
  targetWalletTagLabel: 'تگ آدرس مقصد',
  amountError: 'مبلغ برداشت نباید خالی باشد',
  authenticationCodeError: 'کد شناسایی دو عاملی نباید خالی باشد',
  targetWalletAddressError: 'ادرس کیف مقصد نمی تواندی خالی باشد'

}


const depositScreen: DepositScreen = {
  amount: 'مقدار',
  createWalletButton: 'ایجاد آدرس کیف',
  createWalletDescription: 'برای واریز کوین به کیف خود، با زدن دکمه‌ی زیر یک آدرس والت برای خود ایجاد نمایید',
  currentBalanceTitle: 'موجودی فعلی',
  depositHistoryTitle: 'سابقه واریز',
  description: 'توضیحات',
  myWalletsButton: 'کیف های من',
  pageTitle: 'واریز',
  timeLabel: 'زمان'
}


const moneyDepositScreen: MoneyDepositScreen = {
  addNewCardButton: 'ثبت کارت جدید',
  amountLabel: 'مبلغ',
  bodyText: 'جهت افزایش اعتبار کیف پول ریالی خود با استفاده از کارت‌های بانکی عضو شبکه شتاب و از طریق درگاه پرداخت اینترنتی اقدام نمایید.  در هنگام پرداخت به نکات زیر دقت نمایید:  حتماً به آدرس صفحه‌ی درگاه بانکی دقت نموده و تنها پس از اطمینان از حضور در سایت‌های سامانه‌ی شاپرک مشخصات کارت بانکی خود را وارد نمایید.در صفحه درگاه دقت کنید که حتما مبلغ نمایش داده شده درست باشد.در تعیین مبلغ واریز به این موضوع دقت نمایید که حداقل مبلغ معامله در بازار نوبیتکس صد هزار تومان است. ',
  cardSelectLabel: 'کارت بانکی جهت پرداخت را انتخاب کنید',
  goToBankButton: 'پرداخت',
  pageTitle: 'واریز ریالی',
  amountError: 'مبلغ برداشت نباید خالی باشد',
}


const historyScreens: HistoryScreens = {
  amountLabel: 'مقدار',
  exchangeLabel: 'بازار',
  feeLabel: 'کارمزد',
  filledLabel: 'پرشده',
  orderPriceLabel: 'قیمت سفارش',
  ordersHistoryTitle: 'تاریخچه سفارشات',
  paginationLimitlabel: 'نعداد نمایش',
  sideLabel: 'سمت',
  statusLabel: 'وضعیت',
  timeLabel: 'زمان',
  totalLabel: 'مبلغ کل',
  typeLabel: 'نوع',
  searchLabel: 'جستجو',
  priceLabel: 'قیمت',
  volumeLabel: 'حجم',
  tradeHistoryTitle: 'تاریخچه معاملات',
  balanceLabel: 'موجودی',
  currencyLabel: 'ارز',
  descriptionLabel: 'توضیحات',
  exportReportButton: 'خروجی اکسل',
  transactionHistoryTitle: 'تاریخچه تراکنش ها',
  transactionIDlabel: 'شناسه تراکنش',
  actionsLabel: 'عملیات',
  depositAmountLabel: 'مقدار واریز',
  depositHistoryTitle: 'تاریخچه واریز',
  recivedAmountLabel: 'مقدار دریافتی',
  recivingAddressLabel: 'آدرس دریافت کننده',
  withdrawHistoryTitle: 'تاریخچه برداشت'
}

const profileInfo: ProfileInfo = {
  personalDetailsTitle: 'اطلاعات کاربری',
  fullName: 'نام و نام خانوادگی',
  fistName: 'نام',
  lastName: 'نام',
  nationalCode: 'شماره ملی',
  mobile: 'موبایل',
  save: 'ذخیره',
  bankCards: 'کارت‌های بانکی',
  cardNumber: 'شماره کارت',
  accountInfo: 'اطلاعات بانکی',
  otherInfo: 'اطلاعات تکمیلی',
  myReferals: 'معرف‌های من',
  bankName: 'نام بانک',
  state: 'وضعیت',
  action: 'عملیات',
  IBAN: 'شماره شبا',
  newCard: 'کارت جدید',
  newIBAN: 'شبای جدید',
  address: 'آدرس',
  accepted: 'تایید شده',
  PendingApproval: 'در انتظار تایید',
  currentPassword: 'گذرواژه‌ی فعلی',
  newPassword: 'گذرواژه‌ی جدید',
  confirmPassword: 'تکرار گذرواژه جدید',
  changePasswordTitle: 'تغییر گذرواژه',
  referalTitle: 'ساخت کد دعوت',
  generateReferalCode: 'تولید کد دعوت',

  referralCode: 'کد دعوت',
  yourInvitationLink: 'لینک دعوت شما',
  youRecieve: 'سهم شما',
  friendsRecieve: 'سهم دوستان',
  friends: 'تعداد دوستان',
  totalReferralFees: 'مجموع کارمزد دریافتی شما',
}
const tradeScreen: TradeScreen = {
  buyButton: "خرید",
  sellButton: "فروش",
  lastPriceLabel: "قیمت بازار",
  recivedAmountLabel: "مقدار دریافتی شما",
  sellOrdersLabel: "سفارشات فروش",
  buyOrdersLabel: "سفارشات خرید",
  activeOrdersLabel: "سفارشات باز شما",
  marketRecentOrdersLabel: "آخرین سفارشات بازار",
  orderTotalPricelabel: 'قیمت نهایی'
}

const homeParanox: HomeParanox = {
  title: 'پارانوکس',
}


const translations: TranslationsType = {
  dashboardScreen,
  mainMenu,
  signScreen,
  myWalletScreen,
  general,
  fastConvertScreen,
  withdrawScreen,
  depositScreen,
  moneyDepositScreen,
  historyScreens,
  profileInfo,
  tradeScreen,
  aboutUs,
  confirmations,
  navSearchBox,
  searchRsultPage,
  searchPage,
  navUserLogin,
  mainSlider,
  guneshComponent,
  guneshCard,
  footer,
  product,
  productsContiner,
  navTop,
  elementors,
  recentContent,
  representationCart,
  userPanel,
  signIn,
  newUser,
  productDetile,
  blogItem,
  contactUs,
  blogDetile,
  optionItem,
  productItem,
  cooperate,
  homeParanox,
};


export default translations;
